import React from "react";
import { Icon, Badge } from "@material-ui/core";
import FontAwesomeIcon from "meta/ui2/icon";
import clsx from "clsx";
const TypedIcon = ({ type = "material-icons", size, title, children, style, className, badge, }) => {
    const isMaterial = type.startsWith("material-icons");
    const cn = clsx({ [type]: isMaterial }, className);
    return (<Badge badgeContent={badge}>
      {isMaterial ? (<Icon className={cn} style={{
                fontSize: size || 19,
                marginRight: title ? 8 : undefined,
                ...style,
            }}>
          {children}
        </Icon>) : (<FontAwesomeIcon className={cn} name={children} style={{
                marginRight: title ? 8 : undefined,
                fontSize: size || 20,
                ...style,
            }}/>)}
    </Badge>);
};
export default TypedIcon;
